import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { mutualTheme } from '~/utils/theme'

const useStyles = makeStyles({
  content: {
    margin: mutualTheme.spacing(2),
    marginTop: mutualTheme.spacing(5),
    marginBottom: mutualTheme.spacing(5)
  },
  title: {
    marginBottom: mutualTheme.spacing(2),
    [mutualTheme.breakpoints.down('sm')]: {
      fontSize: mutualTheme.spacing(3)
    }
  }
})

interface FallbackPageContentProps {
  title: string,
  description: string
}

export const FallbackPageContent: React.FC<FallbackPageContentProps> = (props) => {
  const classes = useStyles()

  const { title, description } = props

  return (
    <Box className={classes.content}>
      <Typography className={classes.title} variant='h4' align='center'>
        {title}
      </Typography>
      <Typography align='center'>{description}</Typography>
    </Box>
  )
}
